export enum DriverType
{
    lost = 0,
    mix = 1,
    new = 2,
    existence = 10,
    component = 11,
    outcome = 100,
}